<template>
   <div class="bg-white-background opacity-[1.2]  rounded-4xl w-[350px] sm:w-[400px] h-[400px]">
      <slot/>
   </div>
</template>
